/** App-wide constants. No magic numbers scattered across features. */

/** Platform economics — mirror these in the Stripe edge functions. */
export const PLATFORM = {
  /** WINR's cut of paid-community revenue, in basis points (e.g. 1000 = 10%). */
  feeBps: 1000,
  defaultCurrency: 'USD',
  minWithdrawalCents: 1000,
} as const;

/** Canonical route paths — import these instead of hand-typing strings. */
export const ROUTES = {
  home: '/',
  explore: '/explore',
  about: '/about',
  pricing: '/pricing',
  signIn: '/sign-in',
  authCallback: '/auth/callback',
  onboarding: '/onboarding',
  community: (id = ':communityId') => `/c/${id}`,
  myCommunities: '/communities',
  notifications: '/notifications',
  marketplace: '/marketplace',
  themeStudio: '/studio',
  themeStudioFor: (id = ':communityId') => `/studio/${id}`,
  profileStudio: '/studio/profile',
  inbox: '/inbox',
  inboxPins: '/inbox/pins',
  wallet: '/wallet',
  profile: (handle = ':handle') => `/u/${handle}`,
  profileSelf: '/me',
  settings: '/settings',
  creatorDashboard: '/dashboard',
} as const;
